import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useQuote } from '../../../../hooks';
import { FormattedTimestamp, MultilineTypography } from '../../..';
import { QuoteTypeOfBuy } from '../../../../enums/QuoteTypeOfBuy';
import { QuoteNotesProps } from './QuoteNotes.props';
import { StyledCustomerNote } from './QuoteNotes.styles';

export const QuoteNotes = ({
  internalNotesCount = 0,
  quoteId,
  isAdmin,
  setShowNotesDrawer,
}: QuoteNotesProps) => {
  const { t } = useTranslation();
  const { item: quote } = useQuote(quoteId);

  const noteContent = useCallback(() => {
    if (!quote) {
      return '';
    }

    const content = quote.customerNote?.content || '';
    if (
      quote.typeOfBuy === QuoteTypeOfBuy.ProjectBid ||
      quote.typeOfBuy === QuoteTypeOfBuy.ProjectBuy
    ) {
      return (
        t('quotes.edit.notes.customer.systemDefaultNotice') + '\n' + content
      );
    }

    return content;
  }, [quote, t]);

  return isAdmin ? (
    <Button
      variant="text"
      onClick={() => setShowNotesDrawer && setShowNotesDrawer(true)}
    >
      <Typography variant="body2">
        {t('quotes.edit.summary.quoteDetails.viewNotes', {
          count:
            internalNotesCount +
            (quoteId === 'new' || quote?.customerNote?.content.trim() ? 1 : 0),
        })}
      </Typography>
    </Button>
  ) : (
    quote && (
      <StyledCustomerNote>
        <MultilineTypography variant="body1" sx={{ fontSize: '1rem' }}>
          <>
            <b>{`${t('quotes.edit.summary.quoteDetails.note')}: `}</b>
            {noteContent()}
          </>
        </MultilineTypography>
        {quote.customerNote && (
          <Typography variant="caption">
            {t('quotes.edit.summary.quoteDetails.noteBy', {
              name: quote.customerNote.lastModifiedByName,
            })}
            <FormattedTimestamp timestamp={quote.customerNote.lastModified} />
          </Typography>
        )}
      </StyledCustomerNote>
    )
  );
};
